<template>
<div class="chapter">
<div class="inner_page">
<div>
<h1 class="chapter">A NOTE ON TRANSLITERATION<br/>AND DATING</h1>
<p><span class="dropcaps">T</span>he transliteration of both Arabic and Hebrew has changed according to various systems during my lifetime. In quotations I have adhered to the style used by the author, translator or publisher. For consistency, I have used in the main text the following transliterations of the most frequently used words and names: Mohammed (Muhammad, Mahomet, etc.), Abdullah (Abdallah), Omar (Umar), Hanukah (Chanukah) and Koran (Qur’an).</p>
<p class="indent">The first year of the Muslim era–the year of Mohammed’s emigration from Mecca to Medina–was the year 4,382 in the Jewish calendar and AD 622 in the Christian calendar, also known as the Common Era (CE). I have used the Common Era system for all dates.</p>
<p class="indent">Italicised Arabic and Hebrew words and phrases are listed in the Glossary.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// anote.vue?2027bc2f